module.exports = __webpack_public_path__ + "img/undraw_launch.295b64a1.svg";